import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { loadSimulate } from '@store/ducks/simulate'
import useContact from '@hooks/useContact'
import useInternationalization from '@hooks/useInternationalization'
import calculatePrice from '@client/services/proposal'
import { updateSimulation } from '@client/services/simulate'
import useDataLayer from '@hooks/useDataLayer'

export default function useCoupon() {
  const { country } = useInternationalization()

  const { contact } = useContact()
  const { events } = useDataLayer()
  const [isCouponValid, setIsCouponValid] = useState(false)
  const [hasCoupon, setHasCoupon] = useState(false)

  const dispatch = useDispatch()

  async function handleCoupon(employeesNumber, coupon) {
    const { data } = await calculatePrice(employeesNumber, country, coupon)
    setIsCouponValid(data.coupon && data.coupon.valid)
    setHasCoupon(true)
    const discount = data.value - data.valueWithoutDiscount

    if (data.coupon && data.coupon.valid) {
      const offer = {
        ...contact,
        proposalValue: data.value,
        proposalValueWithoutDiscount: data.valueWithoutDiscount,
        couponCode: data.coupon.code,
        discount,
      }

      dispatch(loadSimulate(offer))

      events.interactionWithCoupom(
        data.coupon.code,
        data.coupon.valid,
        discount * -1,
        data.valueWithoutDiscount,
        data.value
      )

      await updateSimulation(offer)
    }
  }

  return {
    handleCoupon,
    isCouponValid,
    hasCoupon,
  }
}
